import { useRef, useCallback } from 'react';

/**
 * позволяет превратить функцию в вызываемую с дебаунсом
 *
 * @param callback функция, которую необходимо вызывать с дебаунсом
 * @param delay время задержки в миллисекундах
 *
 * @returns массив из двух элементов
 *
 * первый - переданный {@link callback}, вызываемый с задержкой
 *
 * второй - функция, позволяющая вручную отменить исполнение {@link callback} после задержки
 */
var useDebounceCallback = function (callback, delay) {
    var timeoutRef = useRef(null);
    var clearInnerTimeout = useCallback(function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, [timeoutRef]);
    var throttledFunc = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearInnerTimeout();
        timeoutRef.current = setTimeout(function () {
            callback.apply(void 0, args);
            timeoutRef.current = null;
        }, delay);
    }, [timeoutRef, delay, callback, clearInnerTimeout]);
    return [throttledFunc, clearInnerTimeout];
};

export { useDebounceCallback };
